import React from 'react';
import PropTypes from 'prop-types';
import ImageModule from './ArticleModules/ImageModule/ImageModule';
import { isValid } from '../../utils'

const AmazonRSSModule = ({ data, className, isMobile }) => {
  if (!isValid(data)) { return null; }
  const { products=[] } = data;
  const renderedProducts = products.map((product, i) => (
    <ImageModule key={i}
      className='large-image'
      additionalClassName='amazon-product'
      isMobile={isMobile}
      data={product} />
  ));

  return (
    <div className={className}>
      {renderedProducts}
    </div>
  );
};

AmazonRSSModule.propTypes = {
  data: PropTypes.object,
  className: PropTypes.string,
  isMobile: PropTypes.string,
};

export default AmazonRSSModule;
